<app-error-page title="{{message}}" hideSorry="true">
</app-error-page>
